import React from "react";

import sortingGlass from "../../../../public/environment-label-icons/sorting-glass.png";

const IconSortingGlass = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <image href={sortingGlass.src} width={"100%"} height={"100%"} />
  </svg>
);
export default IconSortingGlass;
